import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormField, MatInputModule, MatLabel } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { ApiService } from '../shared/services/api.service';
import { CommonService } from '../shared/services/common.service';
import Swal from 'sweetalert2';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatFormFieldControl, MatFormFieldModule } from '@angular/material/form-field';
import { ExportService } from '../shared/services/exportservice';

@Component({
  selector: 'app-subject-lists',
  imports: [
    MatCardModule,
    MatTableModule,
    MatButtonModule,
    MatMenuModule,
    CommonModule,
    MatLabel,
    MatSelectModule,
    FormsModule,
    MatPaginatorModule,
    MatInputModule,
    MatFormFieldModule,
  ],
  templateUrl: './subject-lists.component.html',
  styleUrl: './subject-lists.component.scss'
})
export class SubjectListsComponent {
  resultType: any;
  selectedSemesterId: string = '';
  selectedCourseId: string = '';
  selectedSemesterNumber: any;
  subjects: any;
  courseList: any;
  semesterList: any;
  currentPage = 0;
  searchText: string = '';
  pagination = {
    length: 0,
    page: 1,
    limit: 10,
  };

  displayedColumns: string[] = [
    'actions', 'sno', 'subject_name', 'qn_code', 'course_code', 'course_name', 'semester_number',
    'credits', 'cie_max', 'cie_pass', 'see_max',
    'see_pass', 'see_cond', 'subject_max', 'subject_min', 'psee_tmax', 'psee_tmin', 'psee_pmax', 'psee_pmin', 'gtot_max', 'gtot_min', 'subject_type', 'scheme_type'
  ];

  constructor(private http: HttpClient, private api: ApiService, private common: CommonService, private exportService: ExportService) { }

  ngOnInit() {
    this.get_all_subjects();
    this.fetch_courses();
    this.getSemesterList();
  }

  onDelete(subject: any) {
    this.delete_single_subject(subject.id)
  }

  get_all_subjects_download() {
    const userData = localStorage.getItem('user');
    const queryParam: any = [];

    if (!userData) {
      console.error('No user data found in localStorage');
      return;
    }

    const user = JSON.parse(userData);
    const payload = {
      user_id: user.userId
    };

    this.api.post(`students/list_all_subjects`, payload, true).subscribe({
      next: (resp: any) => {
        if (resp.status) {
          this.subjects = resp.data;
          this.pagination.length = resp?.totalCount || 0;
          const req = {
            displayedColumns: this.displayedColumns,
            data: this.subjects,
            filename: 'subject_list',
          };
          this.exportService.exportExcel(req);
        } else {
          console.error('Failed to fetch subjects:', resp.message);
        }
      },
      error: (error) => {
        console.error('API error:', error);
      }
    });
  }

  get_all_subjects(courseId?: string, semester_num?: any, search?: string) {
    const userData = localStorage.getItem('user');
    const queryParam: any = [];
    queryParam.push(`page=${this.pagination.page}`, `limit=${this.pagination.limit}`);

    if (!userData) {
      console.error('No user data found in localStorage');
      return;
    }

    const user = JSON.parse(userData);
    interface StudentFilterPayload {
      user_id: string;
      course_id?: string;
      semesterNumber?: number;
      search?: string;
      result_type?: string;
    }

    const payload: StudentFilterPayload = {
      user_id: user.userId
    };

    if (this.selectedCourseId) {
      payload.course_id = courseId
    }
    if (this.selectedSemesterNumber) {
      payload.semesterNumber = semester_num;
    }
    if (search) {
      payload.search = search
    }

    payload.result_type = this.resultType;
    this.api.post(`students/list_all_subjects?${queryParam.join('&')}`, payload, true).subscribe({
      next: (resp: any) => {
        if (resp.status) {
          console.log('students/subjects fetched successfully:', resp.data);
          // You can bind resp.data to a variable for displaying in a table
          this.subjects = resp.data;
          this.pagination.length = resp?.totalCount || 0;
        } else {
          console.error('Failed to fetch subjects:', resp.message);
        }
      },
      error: (error) => {
        console.error('API error:', error);
      }
    });
  }

  // getCourseList() {
  //   this.api.get(`courses/list`).subscribe(resp => {
  //     if (resp && resp.success) {
  //       this.courseList = resp.data;
  //       // this.courseId = resp.data.id
  //     } else {
  //       console.error('Failed to load courses:', resp);
  //       this.courseList = [];
  //     }
  //   });
  // }

  fetch_courses() {
    this.api.get('courses/list').subscribe(resp => {
      if (resp.success) {
        this.courseList = resp.data;
        // this.courseId = resp.data.id
      }
    })
  }

  getSemesterList() {
    this.api.get(`semesters/list`).subscribe(resp => {
      if (resp && resp.success) {
        this.semesterList = resp.data;
        // this.semisterId = resp.data.id
      } else {
        console.error('Failed to load semesters:', resp);
        this.semesterList = [];
      }
    });
  }

  delete_subjects_based_on_filters(courseId: any, semesterNum: any) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You won\'t be able to revert this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        const payload: any = {};
        if (courseId) payload.course_id = courseId;
        if (semesterNum) payload.semester_number = semesterNum;

        this.api.post('students/filter_based_subject_delete', payload, true).subscribe(resp => {
          if (resp.status) {
            this.get_all_subjects();
            Swal.fire('Deleted!', 'Subjects deleted successfully.', 'success');
          } else {
            Swal.fire('Failed!', resp.message, 'error');
          }
        });
      } else {
        Swal.fire('Cancelled', 'Your delete action was cancelled.', 'error');
      }
    });
  }



  delete_single_subject(subjectId: any) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You won\'t be able to revert this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        const payload = {
          subject_id: subjectId,
        };
        this.api.post('students/filter_based_subject_delete', payload, true).subscribe(resp => {
          if (resp.status) {
            this.get_all_subjects();
            Swal.fire('Deleted!', 'The students have been deleted.', 'success');
          }
        });
      } else {
        Swal.fire('Cancelled', 'Your delete action was cancelled.', 'error');
      }
    });
  }

  onFiltersChange() {
    if (this.selectedCourseId && this.selectedSemesterNumber) {
      this.get_all_subjects(this.selectedCourseId, this.selectedSemesterNumber)
    }
  }

  pageEvent(e: any) {
    this.pagination.page = e.pageIndex + 1;
    this.pagination.limit = e.pageSize;
    this.currentPage = e.pageIndex * e.pageSize;
    this.get_all_subjects();
  }

  isDeleteDisabled(): boolean {
    const userData = localStorage.getItem('user')
    const user = JSON.parse(userData)
    const role = user.role;
    if (role === 'staff') {
      return !(this.selectedCourseId && this.selectedSemesterNumber);
    } else {
      return false;
    }
  }

  applyFilter() {
    this.pagination.page = 1;
    this.get_all_subjects(this.selectedCourseId, this.selectedSemesterNumber, this.searchText);
  }

}
